import styled from "styled-components";
import {
  DialogScroll,
  DialogTitle,
  Icon,
} from "discover.medical.react-component-library";

export const DialogContent = styled(DialogScroll)`
  max-height: 23rem;
`;

export const DialogTitleWrapper = styled(DialogTitle)`
  flex-wrap: wrap;
`;

export const DialogUnfollowErrorIcon = styled(Icon)`
  margin-right: ${({ theme }) => theme.space.xs};
`;
